import React, { useContext, useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import BizinBackend from "../../../../helpers/bizin_helper";
import TableSimple from "../../../../components/Dynamic/TableSimple";
import useGetCsrfToken from "../../../../Hooks/useGetCsrfToken";
import { DF_CO0004Context } from "../context";
import { Col, Row } from "reactstrap";
import CardFlow from "../../../../components/Common/CardFlow";
import CardContext from "../../../../components/Common/CardContext";
import { Dropdown } from "primereact/dropdown";
import { Modal, ModalBody } from "reactstrap";
import { tab } from "@testing-library/user-event/dist/cjs/setup/directApi.js";
import useGetHeightPage from "../../../../Hooks/useGetHeightPage";

function GridBody() {
  const csrfToken = useGetCsrfToken();

  const { parseParams } = useContext(DF_CO0004Context);

  const { access_token, isModalPage, user } = useSelector((state) => ({
    access_token: state.login.user.access_token,
    isModalPage: state.Layout.isModalPage,
    user: state.login.profile,
  }));

  const [flowData, setFlowData] = useState([]);
  const [contextData, setContextData] = useState([]);
  const [reasons, setReasons] = useState([]);
  const [selectedReasons, setSelectedReasons] = useState(null);
  const [observation, setObservation] = useState("");
  const [cancelAll, setCancelAll] = useState(false);
  const [loadingCancel, setLoadingCancel] = useState(false);
  const [screenMode, setScreenMode] = useState("normal");
  const [errorMessage, setErrorMessage] = useState("");
  const [openReasons, setOpenReasons] = useState(false);
  const [triggerOnFilter, setTriggerOnFilter] = useState(false);
  const [tableData, setTableData] = useState([]);
  const tableSetDataRef = useRef(null);

  const ID_Arquivo = parseParams.get("ID_Arquivo");

  useGetHeightPage();

  const handleCancelAll = (checked) => {
    setCancelAll(checked);

    tableSetDataRef.current((prev) =>
      prev.map((item) => ({
        ...item,
        Quantidade_Anular: checked ? Number(item.dbQuantidade_Faturada) : "",
      })),
    );
  };

  const handleCancel = () => {
    if (!selectedReasons) {
      setErrorMessage("Selecione o motivo da anulação");

      setScreenMode("error");
      return;
    }

    const itens = tableData.filter(
      (item) => Number(item.Quantidade_Anular) > 0,
    );

    if (itens.length === 0) {
      setErrorMessage("Informe ao menos um item para anular");

      setScreenMode("error");
      return;
    }

    setScreenMode("confirm");
  };

  const confirmCancel = async () => {
    try {
      setLoadingCancel(true);

      const items = tableData.filter(
        (item) => Number(item.Quantidade_Anular) > 0,
      );

      const allItemsCancelled = items.every(
        (item) =>
          Number(item.dbQuantidade_Anulada || 0) +
            Number(item.Quantidade_Anular) >=
          Number(item.dbQuantidade_Faturada),
      );

      await Promise.all(
        items.map((item) =>
          BizinBackend.executeProcedure(
            {
              1: ID_Arquivo,
              2: user.ID_Usuario,
              3: item.intNumero_Item,
              4: Number(item.Quantidade_Anular),
            },
            "SRM_Insere_Notas_Fiscais_Itens_Anulados",
            csrfToken,
            access_token,
          ),
        ),
      );

      await BizinBackend.executeProcedure(
        {
          1: ID_Arquivo,
        },
        "SRM_Notas_Fiscais_Recalcular_Saldo_Pedido",
        csrfToken,
        access_token,
      );

      if (allItemsCancelled) {
        await BizinBackend.executeProcedure(
          {
            1: ID_Arquivo,
          },
          "SRM_Update_Notas_Fiscais_Anuladas_Status",
          csrfToken,
          access_token,
        );
      }

      const dataOcorrencia = new Date()
        .toISOString()
        .slice(0, 23)
        .replace("T", " ");

      await BizinBackend.executeProcedure(
        {
          1: ID_Arquivo,
          2: null,
          3: dataOcorrencia,
          4: null,
          5: null,
          6: `Nota fiscal anulada. Motivo: ${selectedReasons}`,
          7: null,
        },
        "EDI_Inserir_Log_Arquivo",
        csrfToken,
        access_token,
      );

      setScreenMode("success");
    } catch (error) {
      console.log("error on cancellation", error);
      setErrorMessage("Erro ao realizar anulação");

      setScreenMode("error");
    } finally {
      setLoadingCancel(false);
    }
  };

  useEffect(() => {
    setTriggerOnFilter(true);
  }, []);

  useEffect(() => {
    if (!ID_Arquivo) return;
    const loadAllData = async () => {
      try {
        const [flowResp, contextResp, reasonsResp] = await Promise.all([
          BizinBackend.executeProcedure(
            { 1: ID_Arquivo },
            "FRONT_Workspace_Bloco_Fluxo",
            csrfToken,
            access_token,
          ),
          BizinBackend.executeProcedure(
            {
              1: user?.ID_Usuario,
              2: 'pt-BR',
              3: ID_Arquivo,
              4: 'NF',
            },
            "FRONT_Workspace_DF_CO0004_Nota_Fiscal_Obter_Cabecalho",
            csrfToken,
            access_token,
          ),
          BizinBackend.executeProcedure(
            {},
            "EDI_Get_Processos_Config_Dimensoes_Valores_Recusa",
            csrfToken,
            access_token,
          ),
        ]);

        const flowResult =
          flowResp?.data?.resultset_1 ||
          flowResp?.resultset_1 ||
          (Array.isArray(flowResp) ? flowResp : []);

        setFlowData(
          flowResult.map((item) => ({
            name: item.Nome_Empresa,
            description: item.Descricao,
            logo: item.Logo,
          })),
        );

        const contextResult = Array.isArray(contextResp?.data)
          ? contextResp.data
          : Array.isArray(contextResp)
            ? contextResp
            : contextResp?.data?.data ||
              contextResp?.data?.resultset_1 ||
              contextResp?.resultset_1 ||
              [];

        if (contextResult.length > 0) {
          contextResult.map((item) => {
            item.label = item.Coluna;
            item.value = item.Valor;
          })
          setContextData(contextResult);
        }

        const reasonsResult =
          reasonsResp?.data ||
          reasonsResp?.resultset_1 ||
          (Array.isArray(reasonsResp) ? reasonsResp : []);

        setReasons(
          reasonsResult.map((item) => ({
            label: item.Descricao,
            value: item.Descricao,
          })),
        );
      } catch (error) {
        console.log("erro geral ao carregar dados", error);
      }
    };

    loadAllData();
  }, [ID_Arquivo, csrfToken, access_token]);

  const handleCloseModal = () => {
    if (window.top !== window.self) {
      window.parent.postMessage(
        {
          type: "closeModal",
          isReloadPage: true,
        },
        "*",
      );
    } else {
      window.close();
    }
  };

  const renderExpandedRow = (rowData) => {
    return (
      <div className="p-3 bg-light border rounded-3 ms-4">
        <div className="row">
          <div className="col-md-3">
            <strong>Qtde Anulada:</strong>
            <div>{rowData?.dbQuantidade_Anulada ?? "-"}</div>
          </div>

          <div className="col-md-3">
            <strong>Número NF:</strong>
            <div>{rowData?.Numero_NF || "-"}</div>
          </div>

          <div className="col-md-3">
            <strong>Data Emissão:</strong>
            <div>{rowData?.Data_Emissao || "-"}</div>
          </div>

          <div className="col-md-3">
            <strong>Qtde Faturada:</strong>
            <div>{rowData?.dbQuantidade_Faturada ?? "-"}</div>
          </div>
        </div>
      </div>
    );
  };

  const COLUMN_LIST = [
    {
      field: "intNumero_Item",
      header: "Item",
    },
    {
      field: "strCodigo_Barras_Produto",
      header: "Cod. Produto",
    },
    {
      field: "strDescricao_Produto",
      header: "Descrição",
    },
    {
      field: "strUnidade_Medida",
      header: "U.M.",
    },
    {
      field: "dbValor_Total_Bruto_Produto",
      header: "Total Bruto",
    },
    {
      field: "dbQuantidade_Faturada",
      header: "Qtd. Faturada",
    },
    {
      field: "dbQuantidade_Anulada",
      header: "Qtd. Anulada",
    },
    {
      field: "Quantidade_Anular",
      header: "Qtd. Anular",
      width: "10%",
      input: true,
    },
  ];

  return (
    <>
      {screenMode === "normal" && (
        <>
          <Row className={isModalPage ? "" : "mt-3"}>
            <Col md={isModalPage ? 12 : 'auto'}>
              {flowData.length > 0 && (
                <div className="mt-3 mb-2 w-100">
                  <CardFlow flowData={flowData} enableTooltip={false} />
                </div>
              )}
            </Col>
            <Col md={isModalPage ? 12 : ''}>
              {contextData.length > 0 && (
                <div className="mb-3">
                  <CardContext data={contextData} enableTooltip={false} />
                </div>
              )}
            </Col>

            <div className="mb-3 position-relative">
              <label className="fw-semibold text-color-azul1 mb-2">
                Motivo da Anulação
              </label>

              <div
                className="form-control d-flex justify-content-between align-items-center cursor-pointer"
                onClick={() => setOpenReasons(!openReasons)}
              >
                <span>{selectedReasons || "Selecionar"}</span>
                <i
                  className={`fas ${openReasons ? "fa-chevron-up" : "fa-chevron-down"}`}
                />
              </div>

              {openReasons && (
                <div
                  className="shadow mt-1 reasons-dropdown" >
                  {reasons.map((item, index) => (
                    <div
                      key={index}
                      className={`reason-item ${
                        selectedReasons === item.value ? "active" : ""
                      }`}
                      onClick={() => {
                        setSelectedReasons(item.value);
                        //setReasons(false);
                        setOpenReasons(false);
                      }}
                    >
                      <span>{item.label}</span>
                      <i className="fas fa-chevron-right" />
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="mb-3">
              <label className="fw-semibold text-color-azul1 mb-2">
                Observações
              </label>

              <textarea
                className="form-control"
                rows={4}
                placeholder="Digite aqui a observação (opcional)"
                value={observation}
                onChange={(e) => setObservation(e.target.value)}
              />
            </div>
          </Row>
          <Row>
            <Col md={12}>
              <label className="fw-semibold text-color-azul1 mb-2">
                Itens da Nota Fiscal
              </label>

              <TableSimple
                dataKey={"intNumero_Item"}
                procName={"SRM_Get_Nota_Fiscal_Itens"}
                procParams={`[${ID_Arquivo}]`}
                columnsList={COLUMN_LIST}
                enableRowExpansion={false}
                rowExpansionTemplate={renderExpandedRow}
                triggerOnFilter={triggerOnFilter}
                setTriggerOnFilter={setTriggerOnFilter}
                enableDataSharing={true}
                onFilteredDataChange={setTableData}
                externalSetRowData={tableSetDataRef}
              />
            </Col>
          </Row>
          <div className="d-flex justify-content-end align-items-center gap-2 mt-3">
            <input
              type="checkbox"
              className="checkbox-annul"
              checked={cancelAll}
              onChange={(e) => handleCancelAll(e.target.checked)}
            />
            <label className="m-0 lh-1">Anular todos os itens</label>
          </div>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <button
              className="btn fw-semibold btn-cancelar-co0005"
              onClick={() => window.history.back()}
            >
              Cancelar
            </button>

            <button
              className="btn fw-semibold btn-confirmar-co0005"
              onClick={handleCancel}
              disabled={loadingCancel}
            >
              {loadingCancel ? "Anulando..." : "Anular"}
            </button>
          </div>
        </>
      )}

      {screenMode === "confirm" && (
        <div
          className="d-flex flex-column justify-content-center align-items-center text-center"
          style={{ padding: "40px 24px" }}
        >
          <div className="icon-warning">
            <i className="fas fa-exclamation-triangle"></i>
          </div>

          <h5 className="modal-title-custom">
            Realmente deseja anular
            <br />
            os itens da Nota Fiscal?
          </h5>

          <p className="modal-subtext">Esta ação não poderá ser desfeita.</p>

          <div className="modal-actions">
            <button
              className="btn fw-semibold btn-cancelar-co0005"
              onClick={() => setScreenMode("normal")}
            >
              Cancelar
            </button>

            <button
              className="btn fw-semibold btn-confirmar-co0005"
              onClick={confirmCancel}
            >
              Confirmar
            </button>
          </div>
        </div>
      )}

      {screenMode === "success" && (
        <div
          className="d-flex flex-column justify-content-center align-items-center text-center"
          style={{ padding: "40px 24px" }}
        >
          <div className="icon-success">
            <i className="fas fa-check"></i>
          </div>

          <h5 className="modal-title-custom">Sucesso!</h5>

          <p className="modal-subtext">Itens anulados com sucesso!</p>

          <button
            className="btn fw-semibold btn-confirmar-co0005"
            onClick={() => {
              handleCloseModal();
            }}
          >
            Ok!
          </button>
        </div>
      )}

      {screenMode === "error" && (
        <div
          className="d-flex flex-column justify-content-center align-items-center text-center"
          style={{ padding: "40px 24px" }}
        >
          <div className="icon-error">
            <i className="fas fa-times"></i>
          </div>

          <h5 className="modal-title-custom mb-3">Ops!</h5>
          <p className="modal-subtext">
            Não foi possível completar a operação.
          </p>

          <p className="modal-subtext">{errorMessage}</p>

          <button
            className="btn fw-semibold btn-confirmar-co0005"
            onClick={() => setScreenMode("normal")}
          >
            Ok!
          </button>
        </div>
      )}
    </>
  );
}

export default GridBody;
